import $ from 'jquery';

$(document).ready(function () {
	// Header
	$('.main-menu-container .search-button').on({
		click: function () {
			$('.header-top .search-bar-container').toggleClass('show');
			$('.header-mobile .search-bar-container').toggleClass('show');
			$('.header-top .search-bar-container .search-input').focus();
		},
	});

	$('.top-menu .search-button').on({
		click: function () {
			$('.header-top .search-bar-container').toggleClass('show');
			$('.header-mobile .search-bar-container').toggleClass('show');
			$('.header-top .search-bar-container .search-input').focus();
		},
	});

	$('.header-mobile .top-container .search-menu-buttons .search-button img').on({
		click: function () {
			$('.header-top .search-bar-container').toggleClass('show');
			$('.header-mobile .search-bar-container').toggleClass('show');
			$('.header-mobile .search-bar-container .search-input').focus();
		},
	});

	$('.header-top .search-bar-container .search-bar .search-btn figure img').on({
		click: function () {
			$('.header-top .search-bar-container').removeClass('show');
			$('.header-mobile .search-bar-container').removeClass('show');
		},
	});

	$('.header-mobile .search-bar-container .search-bar .search-btn figure img').on({
		click: function () {
			$('.header-top .search-bar-container').removeClass('show');
			$('.header-mobile .search-bar-container').removeClass('show');
		},
	});
})
